var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import FormHelperText from '@mui/material/FormHelperText';
import SelectMui from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import { Controller } from 'react-hook-form';
import Typography from '@mui/material/Typography';
import { colorPalette } from '@repo/mui-config/color-palette';
export function SelectCustom(_a) {
    var ariaLabelledby = _a.ariaLabelledby, name = _a.name, options = _a.options, defaultValue = _a.defaultValue, placeholder = _a.placeholder, props = __rest(_a, ["ariaLabelledby", "name", "options", "defaultValue", "placeholder"]);
    return (_jsx(Controller, { defaultValue: defaultValue, name: name, render: function (_a) {
            var _b;
            var field = _a.field, fieldState = _a.fieldState;
            return (_jsxs(FormControl, { error: Boolean(fieldState.error), fullWidth: true, sx: {
                    background: colorPalette.primary.light,
                    paddingX: 3,
                    paddingY: 2,
                    borderRadius: '10px',
                }, variant: "standard", children: [_jsxs(SelectMui, __assign({}, field, { "aria-labelledby": ariaLabelledby || name, displayEmpty: true, error: Boolean(fieldState.error), labelId: "".concat(name, "-label") }, props, { sx: {
                            marginTop: 0,
                            '&.MuiInputBase-root': {
                                marginTop: 0,
                            },
                            '&:before': {
                                borderBottom: 'none',
                            },
                            '&:after': {
                                borderBottom: 'none',
                            },
                            '&:hover:not(.Mui-disabled):before': {
                                borderBottom: 'none',
                            },
                        }, children: [placeholder ? (_jsx(MenuItem, { disabled: true, value: "", children: _jsx(Typography, { fontWeight: 500, children: placeholder }) })) : null, options.map(function (elem) { return (_jsx(MenuItem, { value: elem.value, children: elem.name }, elem.id)); })] })), ((_b = fieldState.error) === null || _b === void 0 ? void 0 : _b.message) ? (_jsx(FormHelperText, { sx: { position: 'absolute', bottom: '-22px' }, children: fieldState.error.message })) : null] }));
        } }));
}
